import React from 'react'
import { connect } from 'react-redux'
import ImageLoader from 'alt-imageloader'
import Title from '../components/Title.jsx'

const AboutContainer = props => (
    <div>
        <div className="about-header">
            <div className="landing-background">
                <ImageLoader
                    background="/images/bck/bed_about.jpg"
                    animationDelay={200}
                />
            </div>
            <div className="container">
                <div className="row">
                    <div className="col-md-12">
                        <div className="about-info">
                            <h1 className="about-info__title">
                                bedrina
                                <span className="about-info__title about-info__title--white"> projekt</span>
                            </h1>
                            <h2 className="about-info__subtitle">
                                {props.langData.subtitle}
                            </h2>
                            <p className="paragraph about-info__text">{props.langData.text}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div className="section-body">
            <div className="section-spacing section-spacing--underbackground">
                <div>
                    <Title
                        title={props.langData.founderTitle}
                        className="header1--center"
                    />
                    <div className="container">
                        <div className="row founder-row">
                            <div className="col-md-6 col-sm-6">
                                <div className="founder-item founder-item--margin">
                                    <div className="founder-item-image">
                                        <img
                                            className="founder-item-image__img"
                                            src="/images/bck/bed_goran.jpg"
                                        />
                                    </div>
                                    <h3 className="founder-item__name">
                                        Goran Bedrina
                                    </h3>
                                    <p className="founder-item__work">
                                        {props.langData.founderWork1}
                                    </p>
                                </div>
                            </div>
                            <div className="col-md-6 col-sm-6">
                                <div className="founder-item">
                                    <div className="founder-item-image">
                                        <img
                                            className="founder-item-image__img"
                                            src="/images/bck/bed_andrej.jpg"
                                        />
                                    </div>
                                    <h3 className="founder-item__name">
                                        Andrej Bedrina
                                    </h3>
                                    <p className="founder-item__work">
                                        {props.langData.founderWork2}
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="section-spacing section-spacing--last">
                <Title title={props.langData.title} className="header1--center" />
                <div className="container">
                    <div className="row about-contact">
                        <div className="col-md-4 col-sm-4">
                            <div className="about-contact-item">
                                <img
                                    className="about-contact-item__img"
                                    src="/images/ico/bed_pin.png"
                                />
                                <h2 className="about-contact-item__title">{props.langData.adressTitle}</h2>
                                <p className="about-contact-item__text">Bedrina Projekt d.o.o.</p>
                                <p className="about-contact-item__text">Lovrečka 6, 52440 Poreč</p>
                                <p className="about-contact-item__text">{`Mate Vlašića 20, 52440 Poreč(${props.langData.officeTitle})`}</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="about-contact-item">
                                <img
                                    className="about-contact-item__img"
                                    src="/images/ico/bed_mobile.png"
                                />
                                <h2 className="about-contact-item__title">{props.langData.contactTitle}</h2>
                                <p className="about-contact-item__text">GORAN +385 98 912 4789</p>
                                <p className="about-contact-item__text">ANDREJ +385 99 234 5238</p>
                                <p className="about-contact-item__text">VLADIMIR +385 99 242 0827</p>
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4">
                            <div className="about-contact-item">
                                <img
                                    className="about-contact-item__img"
                                    src="/images/ico/bed_bank.png"
                                />
                                <h2 className="about-contact-item__title">{props.langData.accountTitle}</h2>
                                <p className="about-contact-item__text">Zagrebačka Banka dd</p>
                                <p className="about-contact-item__text">IBAN HR2923600001101416903</p>
                                <p className="about-contact-item__text">OIB 76065384226</p>
                            </div>
                        </div>
                    </div>
                    <div className="row invisible">
                        <div className="col-md-8 col-sm-8 about-gallery-col">
                            <div
                                className="about-gallery-img about-gallery-img--big"
                                style={{ background: 'url(/images/bck/bed_about3.jpg)' }}
                            >
                            </div>
                        </div>
                        <div className="col-md-4 col-sm-4 about-gallery-col">
                            <div
                                className="about-gallery-img about-gallery-img--small"
                                style={{ background: 'url(/images/bck/bed_about2.jpg)' }}
                            >
                            </div>
                            <div
                                className="about-gallery-img about-gallery-img--small"
                                style={{ background: 'url(/images/bck/bed_about1.jpg)' }}
                            >
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
)

const mapStateToProps = state => ({
    langData: state.langData.about
})

export default connect(mapStateToProps)(AboutContainer)



// WEBPACK FOOTER //
// ./src/scripts/containers/AboutContainer.jsx